import React, { useContext, useEffect, useState } from "react"
import { NavContext } from "@yumgmbh/gatsby-plugin-sb-nav/src/context/NavContext"
import { Link } from "gatsby"
import {
  IbmWatsonKnowledgeCatalog20,
  NotebookReference20,
  Tools20,
} from "@carbon/icons-react"

const CategoryMenu = () => {
  const [currentPath, setCurrentPath] = useState(null)
  const { navData } = useContext(NavContext) || {
    navData: {},
  }

  useEffect(() => {
    setCurrentPath(window?.location?.pathname?.slice(1))
  }, [])

  return (
    <section>
      <div className="pt-10 pb-8">
        <div className="mx-auto max-w-screen-xl">
          <div className="flex flex-row overflow-y-auto px-grid">
            {navData?.categoryNavigation?.navigation?.map((item, index) => (
              <Link
                key={index}
                className={`btn rounded-xl py-1.5 text-lg uppercase font-bold whitespace-nowrap ${
                  currentPath === item.link.cached_url
                    ? "bg-primary text-white pointer-events-none"
                    : " bg-gray-50 hover:bg-gray-100 "
                } ${index > 0 ? "ml-4" : ""}`}
                to={`/${item.link.cached_url}`}
              >
                {item.title === "News" && (
                  <NotebookReference20
                    className={`inline-block mr-2 -mt-1  ${
                      currentPath === item.link.cached_url
                        ? "text-white"
                        : "text-primary"
                    }`}
                  />
                )}
                {item.title === "How-to" && (
                  <Tools20
                    className={`inline-block mr-2 -mt-1  ${
                      currentPath === item.link.cached_url
                        ? "text-white"
                        : "text-primary"
                    }`}
                  />
                )}
                {item.title === "Know-how" && (
                  <IbmWatsonKnowledgeCatalog20
                    className={`inline-block mr-2 -mt-1  ${
                      currentPath === item.link.cached_url
                        ? "text-white"
                        : "text-primary"
                    }`}
                  />
                )}
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CategoryMenu
